(function () {
    'use strict';

    angular.module('ib-origin-info-module')
        .controller('OriginInfoController', OriginInfoController);

    OriginInfoController.$inject = ['$scope'];
    function OriginInfoController ($scope) {
        const vm = this;
        vm.useOriginForAll = useOriginForAll;
        vm.$onInit = activate;

        ////////////////

        function activate () {

        }


        function useOriginForAll () {
            $scope.$emit('updateOriginForAll', vm.index);
        }
    }
})();